import {
    ClientPageSectionModel,
    PageSectionFieldValidator
} from '../../domain/models/dynamic-form-schema.model';

type ColumnField = ClientPageSectionModel['rows'][number]['fields'][number];

export function getExtraValidatorsForField(
    field: ColumnField
): PageSectionFieldValidator[] {
    const extra: PageSectionFieldValidator[] = [];

    if (field.key.toLowerCase() == 'birthdate') {
        extra.push({
            name: 'minimumAge',
            message: 'shared.error.min.age',
            args: { value: 16 }
        });

        extra.push({
            name: 'maximumAge',
            message: 'shared.error.max.age',
            args: { value: 100 }
        });
    }

    if (field.key.toLowerCase() === 'email') {
        extra.push({
            name: 'emailRequiredForContactPreference',
            message: 'shared.error.required.email',
            args: undefined
        });
    }

    if (field.key.toLowerCase().includes('email')) {
        extra.push({
            name: 'email',
            message: 'shared.error.required.email',
            args: undefined
        });
    }

    if (field.key.toLowerCase() === 'consentreceivetextmessage') {
        extra.push({
            name: 'consentTextMessageRequired',
            message: 'shared.error.required.consent-receive-text-message',
            args: undefined
        });
    }

    if (field.key.toLowerCase() === 'computerequipment') {
        extra.push({
            name: 'computerEquipmentRequired',
            message: 'shared.error.required.computer-equipment',
            args: undefined
        });
    }

    if (field.type.toLowerCase() === 'signature-date') {
        extra.push({
            name: 'signatureDate',
            message: 'shared.error.required.current-date',
            args: undefined
        });
    }

    if (field.type.toLowerCase() === 'future-year-date') {
        extra.push({
            name: 'futureYear',
            message: 'shared.error.required.current-date',
            args: undefined
        });
    }

    return extra;
}
